
const type2Endpoint = {
    Elixirs: 'https://wizard-world-api.herokuapp.com/Elixirs',
    Houses: 'https://wizard-world-api.herokuapp.com/Houses',
    Spells: 'https://wizard-world-api.herokuapp.com/Spells',
}

export async function searchInfo(page, searchText, searchFilter){
     
    const url = type2Endpoint[[page]]
    let query
    
    if(searchText && Object.keys(searchFilter).length){
        const mergeParams = {'name' : searchText.charAt(0).toUpperCase() + searchText.slice(1), ...searchFilter}
        query = new URLSearchParams(mergeParams)
    }
    else if(Object.keys(searchFilter).length){
        const mergeParams = {...searchFilter}
        query = new URLSearchParams(mergeParams)
    }
    else if(searchText){
        const mergeParams = {'name' : searchText.charAt(0).toUpperCase() + searchText.slice(1)}
        query = new URLSearchParams(mergeParams)
    }
    else query = new URLSearchParams({})

    
    const options = {
        method: 'GET',
    };

    function getResultACB(data){
        
        return data
    }

    function gotResponseACB(resp){
        return resp.json()
    }

    if (page === 'Elixirs') {
        const elixirsData = await fetch(`${url}?${query}`, options).then(gotResponseACB).then(getResultACB);
        const elixirImageData = await fetch('https://retoolapi.dev/ESRYlt/potions').then(gotResponseACB).then(getResultACB);

        const elixirsWithImages = await Promise.all(elixirsData.map(async (elixir) => {
            const matchingElixir = elixirImageData.find(data => data.name === elixir.name);
            const image = matchingElixir ? matchingElixir.image : null;
            
            return { ...elixir, image };
        }));

        return elixirsWithImages;
    }

    return fetch(`${url}?${query}`, options).then(gotResponseACB).then(getResultACB)
}

export async function searchCharacters(searchText, searchFilter){
    const baseUrl = 'https://harry-potter-api-3a23c827ee69.herokuapp.com/api/characters'
    const options = {
        method: 'GET',
    };
    var query = ''
    if(searchFilter.house){
        query = `/house/${searchFilter.house}`
    }

    function filterStatusACB(data){
        if(searchFilter.status == 'students') return data.filter(d => d.hogwartsStudent == true)
        else if(searchFilter.status == 'staff') return data.filter(d => d.hogwartsStaff == true)
        return data
    }

    function filterNameACB(data){
        if(searchText) return data.filter(d => d.name.toLowerCase().includes(searchText.toLowerCase()))
        return data
    }

    function getResultACB(data){
        return data
    }

    function gotResponseACB(resp){
        return resp.json()
    }   
    return fetch(`${baseUrl}${query}`, options).then(gotResponseACB).then(getResultACB).then(filterNameACB).then(filterStatusACB)
}


export function json2Object(filePath, fileName){

    var fs = require('fs');
    //return fetch(`${filePath}${fileName}`).then((resp) => resp.json()).then((json) => console.log(json))

}